// NEW STYPEPARAMS METHOD
var GROUPS_ORDER = {
    BY_HEIGHT: 'BY_HEIGHT',
    LEFT_TO_RIGHT: 'LEFT_TO_RIGHT',
};
export default GROUPS_ORDER;
//# sourceMappingURL=layoutParams_structure_groupsOrder.js.map